module.exports = __webpack_public_path__ + "static/media/certificate.c49e5209.png";